import Swiper, { Scrollbar } from 'swiper';

export default class SwiperCarouselFixHeightWidget {
    _listSlider;
    _classSlider;

    constructor(opts = {}) {
        this._listSlider = null;
        this._classSlider = opts.classSlider || '.js-swiper-carouselFixHeight';
    }

    _createSlider(element){
        var slider = new Swiper(element, {
            modules: [Scrollbar],
            loop: false,
            // allowTouchMove: false,
            spaceBetween: 20,
            slidesPerView: 'auto',
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                hide: false
            },
        });
    }

    init(){

        this._listSlider = document.querySelectorAll(this._classSlider);

        if (this._listSlider.length > 0) {
            Array.from(this._listSlider).forEach((element) => {
                this._createSlider(element);
            });
            console.log('Slider Carousel Fix Height Init');
        }
    }
}
